FamilycardsImageLibrary.controller('uploadImagesController', [ '$scope', '$http', 'Upload', function( $scope, $http, Upload ) {

	$scope.fileUploadForm = {};
	$scope.files = {};

	$scope.$watch('fileUploadForm.files', function () {
        $scope.upload($scope.fileUploadForm.files);
    });

    $scope.upload = function (files) {

        if (files && files.length) {

            for (var i = 0; i < files.length; i++) {
                var file = files[i];

                $scope.files[file.name] = { name: file.name };

                if (!file.$error) {
                	
                    Upload.upload({

                        url: '/api/beelden/uploaden/',
                        method: 'POST',
                        data: {
                            image: file  
                        }

                    }).then(function (resp) {
                        $scope.files[resp.config.data.image.name] = resp.data;
                    }, null, function (evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);         
                    });

                }
            }
        }
    };

}]);